<template lang="html">
  <div id="home-page">

    <section class="banner-section">
      <swiper class="swiper desktop" :options="bannersOptions">
        <swiper-slide v-for="(b, bhInx) in banners.pc" :key="'bhInx-'+bhInx">
          <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }">
            <div class="inside">
              <h4 class="title" v-html="b.title"></h4>

              <p class="p">
                VIAJA POR EL MUNDO MIENTRAS CRECES TU PROPIO<br />
                NEGOCIO HACIENDO EQUIPO CON VIAJARE
              </p>

              <p class="p-button">
                <a class="btn btn-s2 bg-c-primary" @click="openTraveloverModal()">{{ b.button }}</a>
              </p>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="swiper mobile" :options="bannersOptions">
        <swiper-slide v-for="(bm, bmhInx) in banners.movil" :key="'bmhInx-'+bmhInx">
          <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+bm.imageUrl+')' }">
            <img src="public/images/pages/home/banner-m.png">

            <div class="inside">
              <h4 class="title" v-html="bm.title"></h4>

              <p class="p">
                VIAJA POR EL MUNDO MIENTRAS CRECES TU PROPIO NEGOCIO HACIENDO EQUIPO CON VIAJARE
              </p>

              <p class="p-button">
                <a class="btn btn-s2 bg-c-primary" @click="openTraveloverModal()">{{ bm.button }}</a>
              </p>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <section class="container about-section">
      <div class="row">
        <div class="col-lg-6 col-about">
          <div class="box">
            <div class="inside">
              <p>
                <img class="logo" src="public/images/logo.svg">
              </p>

              <h5>
                Conoce <strong>TODOS nuestros productos descargando aquí el catálogo</strong> digital 2025
              </h5>

              <p>
                <a class="btn btn-s2 outline-cprimary" target="_blank" href="https://ofertas.viajare.mx/catalogo.php?tp=1">CATÁLOGO 2025</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-contact">
          <div class="box-contact-1">
            <div class="inside">
              <p>
                <i class="fas fa-lock-alt lock-icon"></i>
              </p>
              <h5>
                Contamos con reconocimientos y alianzas conel Gobierno para hacer que tus compras sean
              </h5>
              <h4>100% seguras</h4>
            </div>
          </div>

          <div class="box-contact-2">
            <div class="col-sm col-logo">
              <img src="public/images/pages/home/SECTUR.svg">
            </div>

            <div class="col-sm col-text">
              <h6>Consulta nuestro registro oficial y actualizado en la Secretaría de Turismo (SECTUR).</h6>
              <h6 class="mt-2">Registro <strong class="f-w-600">04140390979</strong></h6>

              <p class="mt-3">
                <a class="btn btn-s2 outline-csecondary" href="public/pdfs/Registro_Viajare_SECTUR.pdf" target="_blank" download>CONSULTAR</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal Quiero ser Travelover -->
    <b-modal modal-class="modal-info-s1" ref="modal-travelover" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-12 col-info">
          <h4 class="text-center modal-title">Emprende tu éxito con la ayuda de los mejores</h4>

          <div class="box-video">
            <iframe src="https://www.youtube.com/embed/3kgfpWEln50?playlist=3kgfpWEln50&loop=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>

          <div class="box-success-stories">
            <div class="inside">
              <h4 class="text-center f-w-600">Casos de éxito</h4>

              <swiper class="swiper swiper-stories" :options="storiesOption" v-if="showStoriesSlider">
                <swiper-slide v-for="(s, sInx) in storiesImages" :key="'sInx-'+sInx">
                  <div class="col-12 px-0 col-story">
                    <div class="image" @click="openStoriesModal(s.imageUrl)">
                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+s.imageUrl+')' }"></div>
                    </div>
                  </div>
                </swiper-slide>

                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              </swiper>
            </div>
          </div>

          <div class="box-buttons">
            <div class="row">
              <div class="col-lg-6 mb-3 mb-lg-0">
                <a class="btn btn-s1 outline-c-white-2 btn-lg w-100">GUIA TRAVELOVER</a>
              </div>

              <div class="col-lg-6">
                <a class="btn btn-s1 outline-c-white-2 btn-lg w-100" @click="$refs['modal-travelover-form'].show();">CONTÁCTANOS</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!--  -->

    <!-- Modal Formulario Travelover -->
    <b-modal modal-class="modal-info-s1" ref="modal-travelover-form" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-12 col-info">
          <h2 class="mb-3 text-center modal-title" style="letter-spacing: 4px;">¡EMPRENDE!</h2>

          <b-form @submit="onSubmitTravelover">
            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.name"
                type="text"
                placeholder="NOMBRE Y APELLIDO*"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.edad"
                type="number"
                placeholder="EDAD*"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.email"
                type="email"
                placeholder="CORREO ELECTRÓNICO*"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.phone"
                type="text"
                placeholder="NÚMERO DE WHATSAPP*"
                minlength="10"
                maxlength="10"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.estudios"
                type="text"
                placeholder="NIVEL DE ESTUDIOS"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.tiempo"
                type="text"
                placeholder="TIEMPO POR DÍA QUE PODRÍAS DEDICAR AL NEGOCIO*"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formTravelover.experiencia"
                type="text"
                placeholder="¿TIENES EXPERIENCIA PREVIA CON AGENCIAS DE VIAJE?*"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-textarea
                v-model="formTravelover.msg"
                placeholder="¿QUÉ QUIERES LOGRAR CON ESTA INVERSIÓN? (LIBERTAD FINANCIERA, VIVIR VIAJANDO, CONOCER EL MUNDO…)*"
                rows="3"
                max-rows="3"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="text-right">
              <b-button type="submit" class="btn btn-s1 btn-lg outline-c-white-2">¡CONTÁCTENME!</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!--  -->

    <!-- Modal success image -->
    <b-modal modal-class="modal-info-s1" ref="modal-success" size="xl" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <img class="image" :src="successImage">
    </b-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: {
        pc: [
          { imageUrl: 'public/images/pages/home/banner-5.jpg', url: '/#/travelover', title: 'QUIERO SER<br />TRAVELOVER', button: 'MÁS INFORMACIÓN' },
          { imageUrl: 'public/images/pages/home/banner-6.jpg', url: '/#/quiero-viajar?id=1', title: 'QUIERO SER<br />TRAVELOVER', button: 'MÁS INFORMACIÓN' },
        ],
        movil: [
          { imageUrl: 'public/images/pages/home/banner-5-m.jpg', url: '/#/travelover', title: 'QUIERO SER<br />TRAVELOVER', button: 'MÁS INFORMACIÓN' },
          { imageUrl: 'public/images/pages/home/banner-6-m.jpg', url: '/#/quiero-viajar?id=1', title: 'QUIERO SER<br />TRAVELOVER', button: 'MÁS INFORMACIÓN' },
        ],
      },

      formTravelover: {
        name: null,
        email: null,
        phone: null,
        msg: null,
      },

      storiesImages: [
        { imageUrl: 'public/images/pages/travelover/success-img-1.jpg' },
        { imageUrl: 'public/images/pages/travelover/success-img-2.jpg' },
      ],
      showStoriesSlider: false,
      successImage: null,

      // == Carousel options ==
      bannersOptions: {
        loop: false,
        speed: 700,
        effect: 'fade',

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      storiesOption: {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,

        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // }
      }
      // == ==
    }
  },

  methods:{
    getHome(){
      axios.get(tools.url('/api/home')).then((response)=>{
        this.banners = response.data.banners;

      }).catch((error)=>{
        console.log(error);
      })
    },

    openTraveloverModal() {
      this.$refs['modal-travelover'].show();

      setTimeout(()=> {
        this.showStoriesSlider = true;
      }, 500);
    },

    onSubmitTravelover(event) {
      event.preventDefault();

      this.$refs['modal-travelover-form'].hide();

      setTimeout(()=> {
        this.$refs['modal-travelover'].hide();
      }, 500);

    },

    openStoriesModal(image) {
      this.successImage = image;
      this.$refs['modal-success'].show();
    },
  },

  mounted() {
    // this.getHome();
  },
}
</script>
